module.exports = __webpack_public_path__ + "img/symbol_5.b8a37336.png";